import {Component, computed, inject} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {IonBadge, IonButton, IonIcon, IonLabel} from '@ionic/angular/standalone';
import {TranslocoDirective} from '@jsverse/transloco';
import {addIcons} from 'ionicons';
import {chatbubbleEllipsesOutline, peopleOutline, personOutline, searchOutline, settingsOutline} from 'ionicons/icons';
import {NotificationService, TranslateHelperService} from '@services';

@Component({
	selector: 'app-mobile-tab-bar',
	standalone: true,
	templateUrl: './mobile-tab-bar.component.html',
	styleUrls: ['./mobile-tab-bar.component.scss'],
	imports: [
		TranslocoDirective,
		RouterLink,
		RouterLinkActive,
		IonButton,
		IonIcon,
		IonLabel,
		IonBadge
	]
})
export class MobileTabBarComponent {
	private readonly notificationService = inject(NotificationService);
	protected readonly translateService = inject(TranslateHelperService);
	private readonly invitationsSignal = this.notificationService.listenInvitation();
	private readonly privateMessagesSignal = this.notificationService.listenPrivateMessageNotification();
	public readonly contactNotification = computed(() => this.invitationsSignal()?.length ?? 0);
	public readonly privateMessageNotification = computed(() => {
		const notifications = this.privateMessagesSignal();
		if (!notifications || notifications.length === 0) {
			return 0;
		}
		const roomIds = new Set(notifications.map(notification => notification.rid).filter(Boolean));
		return roomIds.size;
	});

	constructor() {
		addIcons({
			searchOutline,
			chatbubbleEllipsesOutline,
			peopleOutline,
			personOutline,
			settingsOutline
		});
	}
}
